<template>
  <div class="vue-mobile-home-wrap">
    <div
    v-if="outageDataLoaded"
    class="mobile-container"
    v-bind:class="{darkMode: isDarkMode}">
      <div class="content">
        <mobile-header
        class="content-row mobile-header"
        :totalEvents="totalEventsQuickview"
        :totalCustomers="totalCustomersQuickview"></mobile-header>
        <map-info-modal
        v-if="mapInfoModalVisible"
        :hideModal="hideMapInfoModal"></map-info-modal>
        <div class="content-row map-container">
          <map-home
          ref="map"
          class="map"
          :isDarkMode="isDarkMode"
          :mapView="mapView"
          :townOutages="townOutages"
          :countyOutages="countyOutages"
          :utilityOutages="utilityOutages"
          :showTownsLayer="showTownsLayer"
          :totalEvents="totalEventsQuickview"
          :mapInfoIconClick="showMapInfoModal"
          :showCountiesLayer="showCountiesLayer"
          :showUtilitiesLayer="showUtilitiesLayer"
          :totalCustomers="totalCustomersQuickview"></map-home>
        </div>
        <div
        v-if="desktopListVisible"
        class="content-row outages-list-container">
          <outages-list
          :isDarkMode="isDarkMode"
          :selectTab="onSelectTab"
          :selectedTab="selectedTab"
          :restoreData="restoreData"
          :townOutages="townOutages_COPY"
          :countyOutages="countyOutages_COPY"
          :utilityOutages="utilityOutages_COPY"
          :filterTownData="filterTownData"
          :filterCountyData="filterCountyData"
          :filterUtilityData="filterUtilityData"
          :showTownsLayer="showTownsLayer"
          :showCountiesLayer="showCountiesLayer"
          :showUtilitiesLayer="showUtilitiesLayer"></outages-list>
        </div>
        <mobile-footer
        class="content-row mobile-footer"
        :user="user"
        :isDarkMode="isDarkMode"
        :userIsAdmin="userIsAdmin"
        :showHelpModal="showHelpModal"
        :showLoginModal="showLoginModal"
        :toggleDarkMode="onToggleDarkMode"
        :toggleDesktopList="toggleDesktopList"
        :showDataModal="showDataModal"
        :desktopListVisible="desktopListVisible"
        :onUserAvatarClicked="onUserAvatarClicked"></mobile-footer>
      </div>
      <help-modal
      v-if="helpModalVisible"
      :user="user"
      :userIsAdmin="userIsAdmin"
      :hideModal="hideHelpModal"/>
      <forgot-password-modal
      v-if="forgotPasswordModalVisible"
      :hideModal="hideForgotPasswordModal"
      :forgotPasswordSuccess="onForgotPasswordSuccess"/>
      <login-modal
      v-if="loginModalVisible"
      :hideModal="hideLoginModal"
      :loginSuccess="onLoginSuccess"
      :newPasswordRequired="onNewPasswordRequired"
      :forgotPasswordSuccess="forgotPasswordSuccess"
      :showForgotPasswordModal="showForgotPasswordModal"></login-modal>
      <force-new-password-modal
      v-if="forceNewPasswordModalVisible"
      :user="forceNewPasswordUser"
      :forceNewPasswordSuccess="onForceNewPasswordSuccess"></force-new-password-modal>
      <uility-outages-modal
      v-if="uilityOutagesModalVisible"
      :refreshOutages="onRefreshOutages"
      :hideModal="onHideUilityOutagesModal"></uility-outages-modal>
      <user-profile-modal
      v-if="userProfileModalVisible"
      :user="user"
      :hideModal="onHideUserProfileModal"></user-profile-modal>
      <!-- <outage-history-modal
      :user="user"
      v-if="dataModalVisible"
      :hideDataModal="hideDataModal"></outage-history-modal> -->
      <data-modal
      :user="user"
      v-if="dataModalVisible"
      :hideModal="hideDataModal"></data-modal>
      <user-menu
      v-if="user && userMenuVisible"
      :user="user"
      :userIsAdmin="userIsAdmin"
      :logOut="onLogOut"
      :hideUserMenu="hideUserMenu"
      :showUserProfileModal="onShowUserProfileModal"
      :showUilityOutagesModal="onShowUilityOutagesModal"></user-menu>
    </div>
  </div>
</template>

<script>
import RepeatedTask from "@/services/RepeatedTask";
import MapHome from "@/components/shared/map/MapHome";
import Authentication from "@/services/authentication";
import constants from "../../resources/constants.json";
import UserMenu from "@/components/shared/user/UserMenu";
import HelpModal from "@/components/shared/modals/HelpModal";
import LoginModal from "@/components/shared/modals/LoginModal";
import MapInfoModal from "@/components/shared/modals/MapInfoModal";
import ForgotPasswordModal from "@/components/shared/modals/ForgotPasswordModal";
import HomeMixin from "@/components/shared/mixins/HomeMixin";
import MobileHeader from "@/components/mobile/mobile-header/MobileHeader";
import MobileFooter from "@/components/mobile/mobile-footer/MobileFooter";
import ForceNewPasswordModal from "@/components/shared/modals/ForceNewPasswordModal";
import UserProfileModal from "@/components/shared/modals/user-profile-modal/UserProfileModal";
// import OutageHistoryModal from "@/components/shared/modals/outage-history-modal/OutageHistoryModal";

import OutagesList from "../shared/outages-list/OutagesList";
import lodash from 'lodash';
import UilityOutagesModal from "@/components/shared/modals/utility-outages-modal/UilityOutagesModal";

import DataModal from "@/components/shared/modals/data-modal/DataModal";


const ORIENTATIONCHANGE_EVENT_NAME = 'orientationchange';

export default {
  name: 'MobileHome',
  mixins: [HomeMixin],
  beforeDestroy() {
    this.repeatedTask.cancel();
    window.removeEventListener(ORIENTATIONCHANGE_EVENT_NAME, this.positionAndDisplayDataList);
  },
  watch: {
    utilityOutages: function () {
      setTimeout(() => {this.createDataCopies()}, 300);
    }
  },
  async created() {
    this.isDarkMode = this.getPreference(constants.DARK_MODE_KEY) === 'true' ? true : false;
    await this.getData();
    this.getCurrentUser();
    this.createDataCopies();
    this.repeatedTask = new RepeatedTask('MobileHome', constants.OUTAGE_DATA_RELOAD_DELAY, this.getData);
    window.addEventListener(ORIENTATIONCHANGE_EVENT_NAME, this.positionAndDisplayDataList);
  },
  components: {
    MapHome,
    UserMenu,
    LoginModal,
    HelpModal,
    MapInfoModal,
    ForgotPasswordModal,
    MobileHeader,
    MobileFooter,
    ForceNewPasswordModal,
    UserProfileModal,
    OutagesList,
    UilityOutagesModal,
    DataModal
    // OutageHistoryModal
  },
  data() {
    return {
      // selectedTab: this.getPreference(constants.DATA_VIEW_KEY) || constants.DEFAULT_MAP_VIEW,
      selectedTab: constants.DEFAULT_MAP_VIEW,
      repeatedTask: undefined,
      desktopListVisible: undefined,
      totalEventsQuickview: 0,
      totalCustomersQuickview: 0,
      isDarkMode: false,
      user: undefined,
      userIsAdmin: undefined,
      townOutages: undefined,
      outageDataLoaded: false,
      countyOutages: undefined,
      mapInfoModalVisible: undefined,
      helpModalVisible: undefined,
      loginModalVisible: false,
      utilityOutages: undefined,
      userMenuVisible: undefined,
      userProfileModalVisible: undefined,
      dataModalVisible: undefined,
      uilityOutagesModalVisible: undefined,
      forgotPasswordModalVisible: undefined,
      mapView: this.getPreference(constants.DATA_VIEW_KEY) || constants.DEFAULT_MAP_VIEW,
      forgotPasswordSuccess: undefined,
      forceNewPasswordModalVisible: undefined
    };
  },
  methods: {
    copyData(sourceObject) {return JSON.parse(JSON.stringify(sourceObject))},
    onToggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      this.setPreference(constants.DARK_MODE_KEY, this.isDarkMode);
    },
    async onRefreshOutages() {
      await this.getData(true);
    },
    toggleDesktopList() {
      this.desktopListVisible = !this.desktopListVisible;
      this.positionAndDisplayDataList();
    },
    showMapInfoModal() {
      this.mapInfoModalVisible = true;
    },
    hideMapInfoModal() {
      this.mapInfoModalVisible = undefined;
    },
    showForgotPasswordModal() {
      this.forgotPasswordModalVisible = true;
    },
    hideForgotPasswordModal() {
      this.forgotPasswordModalVisible = undefined;
    },
    showLoginModal() {
      this.loginModalVisible = true;
    },
    hideLoginModal() {
      this.loginModalVisible = undefined;
    },
    hideUserMenu() {
      this.userMenuVisible = false;
    },
    showUserMenu() {
      this.userMenuVisible = undefined;
    },
    onForgotPasswordSuccess() {
      this.forgotPasswordSuccess = true;
      this.hideForgotPasswordModal();
      this.showLoginModal();
    },
    onUserAvatarClicked() {
      this.userMenuVisible = !this.userMenuVisible;
    },
    onLoginSuccess(user) {
      this.user = user;
      this.username = user.username;
      this.hideLoginModal();
      this.checkIfUserIsAdmin();
    },
    onNewPasswordRequired(user) {
      this.hideLoginModal();
      this.forceNewPasswordUser = user;
      this.forceNewPasswordModalVisible = true;
    },
    onForceNewPasswordSuccess() {
      this.getCurrentUser();
      this.forceNewPasswordModalVisible = undefined;
    },
    onShowUserProfileModal() {
      this.hideUserMenu();
      this.userProfileModalVisible = true;
    },
    onHideUserProfileModal() {
      this.userProfileModalVisible = undefined;
    },
    onShowUilityOutagesModal() {
      this.hideUserMenu();
      this.uilityOutagesModalVisible = true;
    },
    onHideUilityOutagesModal() {
      this.uilityOutagesModalVisible = undefined;
    },
    showHelpModal() {
      this.helpModalVisible = true;
    },
    hideHelpModal() {
      this.helpModalVisible = false;
    },
    showDataModal() {
      this.dataModalVisible = true;
    },
    hideDataModal() {
      this.dataModalVisible = undefined;
    },
    createDataCopies() {
      this.utilityOutages_COPY = this.copyData(this.utilityOutages);
      this.townOutages_COPY = this.copyData(this.townOutages);
      this.countyOutages_COPY = this.copyData(this.countyOutages);
    },
    restoreData() {
      this.utilityOutages_COPY = this.copyData(this.utilityOutages);
      this.townOutages_COPY = this.copyData(this.townOutages);
      this.countyOutages_COPY = this.copyData(this.countyOutages);
      this.$forceUpdate();
    },
    emptytData() {
      this.utilityOutages_COPY = [];
      this.townOutages_COPY = [];
      this.countyOutages_COPY = [];
      this.$forceUpdate();
    },
    filterCountyData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      // normalize the search string
      searchString = searchString.toLowerCase().trim();

      const search = lodash.filter(this.countyOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.countyOutages_COPY = search;
      this.$forceUpdate();
    },
    filterTownData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      // normalize the search string
      searchString = searchString.toLowerCase().trim();

      const search = lodash.filter(this.townOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.townOutages_COPY = search;
      this.$forceUpdate();
    },
    filterUtilityData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      // normalize the search string
      searchString = searchString.toLowerCase().trim();

      const search = lodash.filter(this.utilityOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.utilityOutages_COPY = search;
      this.$forceUpdate();
    },
    positionAndDisplayDataList() {
      if (!this.desktopListVisible){return; }

      setTimeout(() => {
        const $header = document.querySelector('.vue-mobile-header-wrap');
        const $footer = document.querySelector('.vue-mobile-footer-wrap');
        const $dataList = document.querySelector('.outages-list-container');
        const headerHeight = window.getComputedStyle($header).height.replace('px', '');
        const footerHeight = window.getComputedStyle($footer).height.replace('px', '');
        const dataListStyle = $dataList.style;

        dataListStyle.top = (parseInt(headerHeight, 10) - 1) + 'px';
        dataListStyle.bottom = (parseInt(footerHeight, 10) - 1) + 'px';
        dataListStyle.display = 'block';
      }, 250);
    },
    onSelectTab(tab) {
      this.selectedTab = tab;
      this.restoreData();

      switch(tab) {
        case 'county':
        this.showCountiesLayer();
        break;
        case 'town':
          this.showTownsLayer();
        break;
        case 'utility':
          this.showUtilitiesLayer();
        break;
      }
    },
    async onLogOut() {
      try {
        await Authentication.signOut();
        this.user = undefined;
        this.username = undefined;
        this.userMenuVisible = false;
        this.hideLoginModal();
      } catch (error) {
          console.log('onLogOut - CATCH: ', error);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/partials/_variables.scss";

.vue-mobile-home-wrap{
  position: relative;

  .mobile-container{
      .content{
        height: 100%;

        .content-row{
          &.mobile-header{
            position: fixed;
            width: 100%;
            top: 0;
            bottom: 0;
            z-index: 10;
          }

          &.map-container{
            position: relative;
          }

          &.outages-list-container{
            display: none;
            position: absolute;
            width: 100%;
            background-color:$navyBackgroundTrans90;
            z-index: 9;
            overflow-y: hidden;
          }

          &.mobile-footer{
            position: fixed;
            width: 100%;
            left: 0;
            bottom: 0;
            z-index: 10;
          }
        }
      }

      &.darkMode{
        .content-row{
          &.mobile-footer{
            border-top: 1px solid $greyTextTrans65;
          }
        }
      }
  }
}
</style>
